import { DomainEnum, FeatureIdEnum } from '../../enums';

import { AppRouteConfig, Dictionary } from '../../models';

import {
  BrowseConfigurationsAttributes,
  BrowseConfigurationsForm,
  BrowseConfigurationsList,
  SearchConfigurationsForm,
  SearchConfigurationsList
} from '../../views';

import { ROUTER_CONSTS } from '../router.consts';
import { ROUTES_PATHS } from '../routes.paths';

const CONFIGURATIONS_PATHS = Object.assign(ROUTES_PATHS, {
  configurations: 'configurations',
  [DomainEnum.BROWSE]: {
    attribute: `:${ ROUTER_CONSTS.params.attribute.name }`,
    list: `:${ ROUTER_CONSTS.params.attribute.name }/:${ ROUTER_CONSTS.params.attribute.value }`
  }
});

export const CONFIGURATIONS_ROUTES: Dictionary<AppRouteConfig[]> = {
  [DomainEnum.SEARCH]: [
    {
      name: ROUTER_CONSTS.routes.configurations[DomainEnum.SEARCH].list,
      path: CONFIGURATIONS_PATHS.configurations,
      component: SearchConfigurationsList,
      meta: {
        featureId: FeatureIdEnum.CONFIGURATION,
        style: {
          removeContentPadding: true
        }
      }
    }, {
      name: ROUTER_CONSTS.routes.configurations[DomainEnum.SEARCH].create,
      path: `${ CONFIGURATIONS_PATHS.configurations }/${ CONFIGURATIONS_PATHS.actions.create }`,
      component: SearchConfigurationsForm,
      meta: {
        featureId: FeatureIdEnum.CONFIGURATION,
        titleI18nKey: 'createConfiguration',
        parentRouteName: ROUTER_CONSTS.routes.configurations[DomainEnum.SEARCH].list
      }
    }, {
      name: ROUTER_CONSTS.routes.configurations[DomainEnum.SEARCH].update,
      path: `${ CONFIGURATIONS_PATHS.configurations }/${ CONFIGURATIONS_PATHS.actions.update }`,
      component: SearchConfigurationsForm,
      meta: {
        featureId: FeatureIdEnum.CONFIGURATION,
        titleI18nKey: 'updateConfiguration',
        parentRouteName: ROUTER_CONSTS.routes.configurations[DomainEnum.SEARCH].list
      }
    }
  ],
  [DomainEnum.BROWSE]: [
    {
      name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].attributes,
      path: CONFIGURATIONS_PATHS.configurations,
      component: BrowseConfigurationsAttributes,
      meta: {
        featureId: FeatureIdEnum.CONFIGURATION
      },
      children: [
        {
          name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].attribute,
          path: CONFIGURATIONS_PATHS[DomainEnum.BROWSE].attribute,
          meta: {
            featureId: FeatureIdEnum.CONFIGURATION
          }
        }, {
          name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].list,
          path: CONFIGURATIONS_PATHS[DomainEnum.BROWSE].list,
          component: BrowseConfigurationsList,
          meta: {
            featureId: FeatureIdEnum.CONFIGURATION,
            titleI18nKey: 'configurationsList'
          }
        }, {
          name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].create,
          path: `${ CONFIGURATIONS_PATHS[DomainEnum.BROWSE].list }/${ CONFIGURATIONS_PATHS.actions.create }`,
          component: BrowseConfigurationsForm,
          meta: {
            featureId: FeatureIdEnum.CONFIGURATION,
            titleI18nKey: 'createConfiguration',
            parentRouteName: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].list
          }
        }, {
          name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].update,
          path: `${ CONFIGURATIONS_PATHS[DomainEnum.BROWSE].list }/${ CONFIGURATIONS_PATHS.actions.update }`,
          component: BrowseConfigurationsForm,
          meta: {
            featureId: FeatureIdEnum.CONFIGURATION,
            titleI18nKey: 'updateConfiguration',
            parentRouteName: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].list
          }
        }
      ]
    }
  ]
};
